
export class GetPayorBO {
    role: string;
    user: string | null;
    searchColumn: string;
    searchText: string;
    userId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "payorName";
    type: string = "string";
    field: string = "payorName";
    value: string = "";
    listId: string | null;
    operator: string = "startswith";
    matchCase: boolean = false;
}

export class savePayorBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    billingFullName: string;
    payorName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zip: string;
    phoneNumber: string;
    defaultBillType: string;
    payorId: string;
    agencyId: string;
    i837PInsTypeLid: string | null;
    i837PInsType_LovName: string;
    groupLid: string;
    group_LovName: string;
    atypical: boolean;
    npi: string;
    claimFilingIndicatorCode: string;
}
export class CompanyReturnBO {
    id: string;
    payerId: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    fEIN: string;
    adminFullName: string;
    phoneNumber: string;
    fax: string;
    statusName: string;
}
export class getMappedCompanyBO {
    id: string;
    companyId: string;
    payorId: string;
    companyName: string;
    providerNo: string;
    taxonomyCode: string;
    street: string;
    city: string;
    state: string;
    zipCode: string;
    fEIN: string;
    fax: string;
    statusLid: string;
    statusName: string;
    phoneNumber: string;
}
export class PayorCompanyMappingBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    payorId: string;
    companyId: string;
    providerNo: string;
    claim_Filling_Ind: string;
    taxonomyCode: string;
    payerInitialLid:string;
    payerInitialLovcode:string;
}

export class functionpermission {
    payercreate: boolean = true
    payerupdate: boolean = true
    payerdelete: boolean = true
}


